import Message from 'owa-service/lib/contract/Message';
import { getAppropriateItemIds } from './getAppropriateItemIds';
import { SearchResultMessage } from 'mini-3s-service/lib/schema/SubstrateSearchResponse';
import {
    convertToNormalizedSubject,
    convertToItemId,
    convertRecipientToSingleRecipientType,
    convertToFolderId,
    convertSearchSortOrder,
    convertToFlagType,
    convertUtcDateTimeToRequestTimeZone,
} from './converterHelpers';

/**
 * Source : https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web?path=%2Fpackages%2Fcommon%2Fcontrols%2Fpackages%2Fcontrols%2Fsearch%2Fowa-search-service%2Flib%2Fhelpers%2FsubstrateTransformations%2Fresponse%2FconvertSearchResultMessageToMessageType.ts
 */

/**
 * Maps 3s results Message to MessageType from owa-service
 * @param searchResultsMessage
 * @param requestTimeZone
 */
export function mapSearchResultMessageToMessageType(
    searchResultsMessage: SearchResultMessage,
    requestTimeZone: string
): Message {
    const {
        Subject,
        Categories,
        ConversationId,
        ConversationIndex,
        ConversationThreadId,
        DateTimeReceived,
        DateTimeSent,
        DateTimeLastModified,
        DisplayBcc,
        DisplayCc,
        DisplayTo,
        Flag,
        From,
        HasAttachments,
        Hashtags,
        IconIndex,
        Importance,
        IsDraft,
        IsRead,
        ItemClass,
        ItemId,
        MailboxGuids,
        ParentFolderId,
        Preview,
        Sender,
        SenderSMTPAddress,
        Sensitivity,
        ImmutableId,
        SortOrderSource,
        MentionsPreview,
    } = searchResultsMessage;

    const normalizedSubject = convertToNormalizedSubject(Subject);

    return {
        Categories,
        ConversationId: convertToItemId(ConversationId),
        ConversationIndex,
        ConversationThreadId: {
            Id: ConversationThreadId,
            ChangeKey: null,
        },
        ConversationTopic: normalizedSubject,
        DateTimeReceived: convertUtcDateTimeToRequestTimeZone(DateTimeReceived, requestTimeZone),
        DateTimeSent:
            DateTimeSent && convertUtcDateTimeToRequestTimeZone(DateTimeSent, requestTimeZone),
        LastModifiedTime: convertUtcDateTimeToRequestTimeZone(
            DateTimeLastModified,
            requestTimeZone
        ),
        DisplayBcc,
        DisplayCc,
        DisplayTo,
        Flag: convertToFlagType(Flag),
        From: convertRecipientToSingleRecipientType(From),
        HasAttachments,
        Hashtags,
        IconIndex,
        Importance,
        IsDraft,
        IsRead,
        ItemClass: ItemClass || 'IPM.Note',
        ItemId: getAppropriateItemIds(ImmutableId, [ItemId])?.[0] ?? null,
        MailboxGuids,
        ParentFolderId: convertToFolderId(ParentFolderId),
        Preview,
        Sender: convertRecipientToSingleRecipientType(Sender),
        SenderSMTPAddress,
        Sensitivity,
        SerializedImmutableId: ImmutableId,
        SortOrderSource: convertSearchSortOrder(SortOrderSource),
        Subject,
        MentionedMe: MentionsPreview?.IsMentioned,
        ExtendedProperty: [
            {
                // WellKnownProperties.NormalizedSubjectProperty
                ExtendedFieldURI: {
                    DistinguishedPropertySetId: 'Common',
                    PropertyId: 3613,
                    PropertyType: 'String',
                },
                Value: normalizedSubject,
            },
        ],
    };
}
